import config from '@root/config'

export function getDhChatIntegrationId(): string {
    return String(config.marketplaceModulesIds?.[config.buildType]?.dhChat || 'dhChat')
}

export function getMaxBusinessIntegrationId(): string {
    return String(
        config.marketplaceModulesIds?.[config.buildType]?.maxBusiness || 'maxBusiness'
    )
}

export function isDhChatIntegrationId(integrationId: string | null | undefined): boolean {
    if (integrationId == null || integrationId === '') return false
    return String(integrationId) === getDhChatIntegrationId()
}

export function isMaxBusinessIntegrationId(integrationId: string | null | undefined): boolean {
    if (integrationId == null || integrationId === '') return false
    return String(integrationId) === getMaxBusinessIntegrationId()
}

export function getSmsChannelIntegrationId(): string {
    return String(config.marketplaceModulesIds?.[config.buildType]?.sms || 'smsChannelSlot')
}

export function isSmsChannelIntegrationId(integrationId: string | null | undefined): boolean {
    if (integrationId == null || integrationId === '') return false
    return String(integrationId) === getSmsChannelIntegrationId()
}
